// @flow

import React from "react";
import WorkGrid from "../components/WorkGrid";
import styled from "react-emotion";
import { noDummy } from "../utilities";
import CirlceIcon from "../components/CircleIcon";

const Cover = styled.div`
  position: relative;
  z-index: 2;
`;

export default ({ data }) => {
  return (
    <Cover>
      <WorkGrid workItems={noDummy(data.work.edges)} />
    </Cover>
  );
};

export const pageQuery = graphql`
  query WorkPages {
    work: allPrismicArticle(
      sort: { fields: [first_publication_date], order: DESC }
    ) {
      edges {
        ...Article
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/work.js